import gql from 'graphql-tag'

export const AFTERSALES_FORM = gql`
  query AFTERSALES_FORM($site: [String]) {
    form: formieForm(handle: "afterSalesSupport", site: $site) {
      ... on afterSalesSupport_Form {
        formFields {
        id
        handle
        typeName
        label
        required
        visibility
        ... on Field_Dropdown {
              id
              options {
                value
                key: value
                label
                isDefault
              }
            }
        }
      }
    }
  }
`
